<ng-container *ngIf="imageBlock?.file?.signedUrl; else showPlaceholder">
  <img
    [src]="imageBlock?.file?.signedUrl"
    aria-label="Placeholder Image"
    alt="File Location Image"
  />
</ng-container>
<ng-template #showPlaceholder>
  <img
    src="assets/img/560x315.png"
    aria-label="Placeholder Image"
    alt="Placeholder Image"
  />
</ng-template>
